import { isTenantAdministrator } from './administratorAccess';

// The API independently checks active tenant authority and live operator grants.
export function canAccessFinance(user) {
  return isTenantAdministrator(user) || Boolean(user?.roles?.some(role => role.key === 'VERWALTER'));
}
